import ImageBanner from '../wrappers/ImageBanner/IrisImageBannerLazy';
import ImageMapBanner from '../wrappers/ImageMapBanner/IrisImageBannerLazy';
import IrisShoppableImagesLazy from '../../components/ShoppableImages/IrisShoppableImagesLazy';
import GoogleAds from '../wrappers/GoogleAds/IrisGoogleAdsLazy';
import CategoryDeals from '../../components/CategoryDeals/IrisCategoryDealsLazy';
import PromotionalBanner from '../wrappers/PromotionalBanner/IrisPromotionalBannerLazy';
import StickyTimer from '../wrappers/StickyTimer/IrisStickyTimerLazy';
import EditorialContent from '../../components/EditorialContent/IrisEditorialContentLazy';
import Grid from '../wrappers/Grid/IrisGridLazy';

export default {
    ads: {
        component: GoogleAds,
    },
    imagebanner: {
        component: ImageBanner,
    },
    imagehotspots: {
        component: ImageMapBanner,
    },
    nucleus: {
        component: EditorialContent,
    },
    editorial: {
        component: EditorialContent,
    },
    story: {
        component: EditorialContent,
    },
    hero: {
        component: EditorialContent,
    },
    herovariant: {
        component: EditorialContent,
    },
    textbanner: {
        component: PromotionalBanner,
    },
    categorypromo: {
        component: CategoryDeals,
    },
    categoryhotdeals: {
        component: CategoryDeals,
    },
    timer: {
        component: StickyTimer,
    },
    gridcomponent: {
        component: Grid,
    },
    shoppableimages: {
        component: IrisShoppableImagesLazy,
    },
};
